/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';

import { CONFIG_TOKEN } from '@core/tokens';

import { TagEvent } from './types/tag.type';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: any;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  readonly #config = inject(CONFIG_TOKEN);

  constructor() {
    this.initWindowDataLayer();

    if (this.#config.googleTagManagerId) {
      this.initGtag();
    }
  }

  public pushEvent(tagEvent: TagEvent): void {
    const eventClone = structuredClone(tagEvent);

    window.dataLayer.push(eventClone);
  }

  private initWindowDataLayer(): void {
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
  }

  private initGtag(): void {
    (function (w: any, d: any, s: any, l: any, i: any) {
      w[l] = w[l] || [];
      w[l].push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      const f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? `&l=${l}` : '';
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', this.#config.googleTagManagerId);
  }
}
